/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedUspContractTypeDropdown200,
  GetApiV1PersonSharedUspContractTypeDropdown401,
  GetApiV1PersonSharedUspContractTypeDropdown500,
  GetApiV1PersonSharedUspContractTypeDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedUspContractTypeDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedUspContractTypeDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedUspContractTypeDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedUspContractTypeDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedUspContractTypeDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedUspContractTypeDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedUspContractTypeDropdown500>;

export const getApiV1PersonSharedUspContractTypeDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedUspContractTypeDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedUspContractTypeDropdownQueryResponse>;
